import React, { FC } from 'react'
import styles from "../../assets/styles/appointments.module.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
interface PropsTypes {
    chartData: BarChartDataType[] | [];
    title?: string;
}
const XBarChart: FC<PropsTypes> = ({ chartData, title }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg p-4">
            {
                title &&
                <div className={styles.chartHeadAndBtn}>
                    <h3>{title}</h3>
                </div>
            }
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData} layout="vertical" margin={{ left: 60 }}>
                    <XAxis type="number" />
                    <YAxis type="category" dataKey="name" style={{ fontSize: "12px", whiteSpace: "nowrap" }} />
                    <Tooltip />
                    <Bar dataKey="value" fill="#0562cc" barSize={20} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default XBarChart